import React, {useEffect} from "react";
import {useLocation, useParams} from "react-router";
import {useDispatch} from "react-redux";
import Header from "./header/Header";
import Content from "./content/Content";
import layout from "../../styles/layout.module.scss";

export default () => {
    const params = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const flavour = params.flavour;

    useEffect(() => {
        dispatch({
            type: "CVS2:WIZARD-START",
            payload: { cvsFlavour: flavour, accountId: location.search.split("=")[1] }
        });
    }, [flavour, location]);

    return (
        <div className={layout["layout"]}>
            <Header flavour={flavour}/>
            <main className={layout["content"]}>
                <Content flavour={flavour}/>
            </main>
        </div>
    );
};


